import "../styles/coursemap.css";

export const SkeletonLoader = () => {
  return (
    <div className="h-full w-full text-center">
      <p
        className="font-black absolute top-1/2 left-1/2 text-8xl"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        LOADING VISUALIZATION ...
      </p>
      <div className="h-full w-full skeleton-loader"></div>
    </div>
  );
};
